module.exports = __webpack_public_path__ + "img/Integral-active.24088fc8.svg";